import './AddTokenForm.css';

import Button from '@atlaskit/button';
import LoadingButton from '@atlaskit/button/loading-button';
import Form, { ErrorMessage, Field, FormFooter } from '@atlaskit/form';
import SectionMessage from '@atlaskit/section-message';
import TextField from '@atlaskit/textfield';
import { Box } from '@fuegokit/react';
import React, { FormEvent, useCallback, useState } from 'react';

const TOGGL_LINK = 'https://track.toggl.com/profile#api-token-label';

interface FormChildrenProps {
  ref: React.RefObject<HTMLFormElement>;
  onSubmit: (
    event?: React.FormEvent<HTMLFormElement> | React.SyntheticEvent<HTMLElement>
  ) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLElement>) => void;
}

function Link() {
  return (
    <a href={TOGGL_LINK} target="_blank">
      <Button appearance="link" spacing="none">
        Open Toggl site
      </Button>
    </a>
  );
}

export function AddTokenForm({
  onSubmit,
}: {
  onSubmit: (token: string) => Promise<{ token: boolean } | undefined>;
}) {
  const [token, setToken] = useState<string>('');

  const onFormSubmit = useCallback(async () => {
    return onSubmit(token);
  }, [token]);

  return (
    <Box p={2}>
      <SectionMessage
        title="API token needed"
        appearance="discovery"
        actions={<Link />}
      >
        <p>To run Toggl app you need to provide API token</p>
      </SectionMessage>
      <Form onSubmit={onFormSubmit}>
        {({
          formProps,
          submitting,
        }: Partial<{ formProps: FormChildrenProps; submitting: boolean }>) => (
          <form {...formProps}>
            <Field name="token" label="Token" isRequired>
              {({ error }: Partial<{ error: string | undefined }>) => (
                <>
                  <TextField
                    autoComplete="off"
                    placeholder="Paste Toggl API token here..."
                    onChange={(event: FormEvent<HTMLInputElement>) => {
                      const target = event.target as HTMLInputElement;
                      setToken(target.value);
                    }}
                    value={token}
                  />
                  {error && (
                    <ErrorMessage>
                      Cannot save API token or it is not valid.
                    </ErrorMessage>
                  )}
                </>
              )}
            </Field>
            <FormFooter>
              <LoadingButton
                type="submit"
                isDisabled={!token}
                appearance="primary"
                isLoading={submitting}
                className="align-left"
              >
                Connect
              </LoadingButton>
            </FormFooter>
          </form>
        )}
      </Form>
    </Box>
  );
}
